import { render, staticRenderFns } from "./confirm_result.vue?vue&type=template&id=5c710588&scoped=true&"
import script from "./confirm_result.vue?vue&type=script&lang=js&"
export * from "./confirm_result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c710588",
  null
  
)

export default component.exports